export default __webpack_public_path__ + "static/media/benefits-exercise.36710794.jpg";